import React from 'react';

const createMarkup = (email: any) => ({
  __html: email
});

const PreviewContent: React.FC<Props> = ({ email }) => {
  return <div dangerouslySetInnerHTML={createMarkup(email.body)} />;
};

type Props = {
  email: any;
  errorCallBack?: Function;
};

export default React.memo(PreviewContent);
